import React from 'react';
import { Dropdown } from 'react-bootstrap';
import { ScreenNotification } from '../hooks/useScreenNotifications';
import { IconX } from '@tabler/icons-react';

interface ScreenNotificationPanelProps {
  notifications: ScreenNotification[];
  onDismiss: (id: string) => void;
  onClearAll: () => void;
  onMarkAllAsRead: () => void;
}

export const ScreenNotificationPanel: React.FC<ScreenNotificationPanelProps> = ({
  notifications,
  onDismiss,
  onClearAll,
  onMarkAllAsRead,
}) => {
  const formatTimestamp = (timestamp: number): string => {
    const now = Date.now();
    const diff = now - timestamp;

    const minutes = Math.floor(diff / 60000);
    if (minutes < 1) return 'Práve teraz';
    if (minutes < 60) return `Pred ${minutes} min`;

    const hours = Math.floor(minutes / 60);
    if (hours < 24) return `Pred ${hours} h`;

    const days = Math.floor(hours / 24);
    return `Pred ${days} d`;
  };

  return (
    <Dropdown.Menu style={{ width: '350px', maxHeight: '400px', overflowY: 'auto' }}>
      <div className="d-flex justify-content-between align-items-center px-3 py-2 border-bottom">
        <h6 className="mb-0">Notifikácie</h6>
      </div>

      {notifications.length === 0 ? (
        <div className="px-3 py-4 text-center text-muted">
          <p className="mb-0">Žiadne nové notifikácie</p>
        </div>
      ) : (
        <div>
          {notifications.map((notification) => (
            <div
              key={notification.id}
              className={`px-3 py-2 border-bottom ${
                !notification.read ? 'bg-light' : ''
              }`}
              style={{ position: 'relative' }}
            >
              <div className="d-flex justify-content-between align-items-start">
                <div style={{ flex: 1, paddingRight: '24px' }}>
                  <div className="d-flex align-items-center mb-1">
                    {!notification.read && (
                      <span
                        className="badge bg-primary me-2"
                        style={{ width: '8px', height: '8px', padding: 0, borderRadius: '50%' }}
                      />
                    )}
                    <strong style={{ fontSize: '0.875rem' }}>
                      {notification.action === 'created' && 'Nový záznam'}
                      {notification.action === 'updated' && 'Aktualizovaný'}
                      {notification.action === 'deleted' && 'Odstránený'}
                    </strong>
                  </div>
                  <div style={{ fontSize: '0.875rem' }} className="mb-1">
                    {notification.recordText}
                  </div>
                  {notification.user && (
                    <div style={{ fontSize: '0.75rem' }} className="text-muted mb-1">
                      {notification.action === 'created' && `Pridal: ${notification.user}`}
                      {notification.action === 'updated' && `Zmenil: ${notification.user}`}
                      {notification.action === 'deleted' && `Odstránil: ${notification.user}`}
                    </div>
                  )}
                  <div style={{ fontSize: '0.75rem' }} className="text-muted">
                    {formatTimestamp(notification.timestamp)}
                  </div>
                </div>
                <button
                  className="btn btn-sm btn-link text-muted p-0"
                  onClick={(e) => {
                    e.stopPropagation();
                    onDismiss(notification.id);
                  }}
                  style={{ position: 'absolute', top: '8px', right: '8px' }}
                  title="Odstrániť notifikáciu"
                >
                  <IconX size={16} />
                </button>
              </div>
            </div>
          ))}
        </div>
      )}
    </Dropdown.Menu>
  );
};
